import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import { MdDone } from "react-icons/md";
import { FaPencil } from "react-icons/fa6";
import CustomButton from "../../Components/CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

// Max allowed price: 99999.99
const MAX_PRICE = 99999.99;
// Valid: digits only, optional single dot, up to 2 decimal places, max 5 digits before decimal
const PRICE_REGEX = /^\d{0,5}(\.\d{0,2})?$/;

const sanitizePrice = (val) => {
  const parsed = parseFloat(val);
  if (isNaN(parsed) || parsed < 0) return "0.00";
  if (parsed > MAX_PRICE) return MAX_PRICE.toFixed(2);
  return parsed.toFixed(2);
};

const Pricing = () => {
  const [isEditableItem, setIsEditableItem] = useState("");
  const [formData, setFormData] = useState({});
  const [indicatorData, setIndicatorData] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    try {
      const LogoutData = localStorage.getItem("login");
      const apiUrl = process.env.REACT_APP_BASE_URL;
      fetch(`${apiUrl}/admin/pricing`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${LogoutData}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          document.querySelector(".loaderBox").classList.add("d-none");
          if (data?.status && data.data.types) {
            const newFormData = {};
            data.data.types.forEach((item) => {
              if (item.key) {
                // Sanitize on load — reject any garbage values stored in DB
                newFormData[item.key.trim()] = sanitizePrice(item.price);
              }
            });
            setFormData(newFormData);
            setIndicatorData(data.data.types);
          }
        });
    } catch (error) {}
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (value === "") {
      setFormData({ ...formData, [name]: value });
      setErrors({ ...errors, [name]: "Price is required." });
      return;
    }

    if (!PRICE_REGEX.test(value)) return; // block alphabets, symbols, extra dots

    const numeric = parseFloat(value);
    if (!isNaN(numeric) && numeric > MAX_PRICE) return; // block values over max

    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    indicatorData.forEach((item) => {
      const key = item.key?.trim();
      const val = formData[key];
      if (val === "" || val === undefined) {
        newErrors[key] = "Price is required.";
      } else {
        const parsed = parseFloat(val);
        if (isNaN(parsed) || parsed < 0) {
          newErrors[key] = "Enter a valid positive number.";
        } else if (parsed > MAX_PRICE) {
          newErrors[key] = `Max allowed value is $${MAX_PRICE.toLocaleString()}.`;
        }
      }
    });
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fix the invalid prices before saving.");
      return;
    }

    const updatedIndicatorData = indicatorData.map((item) => {
      const cleanedKey = item.key?.trim();
      const priceFromForm = formData[cleanedKey];
      return {
        ...item,
        key: cleanedKey,
        price: parseFloat(parseFloat(priceFromForm).toFixed(2)),
      };
    });

    try {
      const LogoutData = localStorage.getItem("login");
      const apiUrl = process.env.REACT_APP_BASE_URL;
      fetch(`${apiUrl}/admin/pricing`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${LogoutData}`,
        },
        body: JSON.stringify({
          types: updatedIndicatorData,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          document.querySelector(".loaderBox").classList.add("d-none");
          toast.success(data.message);
        });
    } catch (error) {
      console.log("Error updating prices", error.message);
      toast.error("Something went wrong.");
    }
  };

  return (
    <DashboardLayout>
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-12">
            <div className="dashCard">
              <div className="d-flex mb-3 justify-content-between">
                <div className="col-md-6 mb-2">
                  <h2 className="mainTitle">Pricings</h2>
                </div>
                <div></div>
                {/* <div className="col-md-4 mb-2">
                    <div className="addUser">
                     <CustomInput type="text" placeholder="Search Here..." value={inputValue} inputClass="mainInput" onChange={handleChange} />
                    </div>
                  </div> */}
              </div>
              <CustomButton
                text="Update Prices"
                variant="primaryFixedButton"
                onClick={handleSubmit}
              />
              <form className="pricingForm" onSubmit={handleSubmit}>
                <div className="row mb-3">
                  {indicatorData.map((item, index) => {
                    return (
                      // <div className="col-12" key={index}>

                      // </div>
                      <div className="mb-3 col-6 mt-3 " key={index}>
                        <div className=" d-flex justify-content-between gap-5">
                          <div className="editableItem">
                            {item.label} :{" "}
                            {isEditableItem === item.key ? (
                              <div className="d-flex flex-column">
                                <div className="d-flex align-items-center">
                                  <span>$</span>
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    autoFocus
                                    name={item.key}
                                    value={formData[item.key] ?? ""}
                                    onChange={handleChange}
                                    placeholder="0.00"
                                    style={{
                                      borderColor: errors[item.key] ? "#dc3545" : undefined,
                                    }}
                                    required
                                  />
                                </div>
                                {errors[item.key] && (
                                  <span style={{ color: "#dc3545", fontSize: "11px", marginTop: "2px" }}>
                                    {errors[item.key]}
                                  </span>
                                )}
                              </div>
                            ) : (
                              <strong>
                                ${parseFloat(formData[item.key] ?? 0).toFixed(2)}
                              </strong>
                            )}
                          </div>

                          {isEditableItem === item.key ? (
                            <span
                              className="edit"
                              onClick={() => setIsEditableItem("")}
                            >
                              <MdDone size={22} />
                            </span>
                          ) : (
                            <span
                              className="edit"
                              onClick={() => setIsEditableItem(item.key)}
                            >
                              <FaPencil size={16} />
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Pricing;
